export default __webpack_public_path__ + "20d9ba40e49d3673b8f0b8f48958af7b.jpeg";